/// <reference path="Assistant.ts" />

namespace TerminalApp {


    export class EditLotAssistant extends Assistant {
        bc_menu = document.createElement("div");
        submit_button: HTMLElement;
        current: SP.StockingLotInfo;

        batch_input: HTMLInputElement;
        arrival_input: HTMLInputElement;
        return_checkbox: SP.CheckboxDoodle;
        quarantine_checkbox: SP.CheckboxDoodle;
        expiration_container: HTMLElement;
        expiration_input: HTMLInputElement;
        item_headline: HTMLElement;
        image_contianer: HTMLElement;
        constructor() {
            super();

            this.initialize();

            this.submit_button = this.bc_menu.querySelector(".btn");
            this.submit_button.addEventListener("click", async () => {
                SP.Sounds.Click.play();

                var postData = {
                    id: this.current.id,
                    arrivalDate: this.arrival_input.value,
                    expirationDate: this.expiration_input.value ? this.expiration_input.value : null,
                    batchNumber: this.batch_input.value,
                    isReturn: this.return_checkbox.checked,
                    quarantine: this.quarantine_checkbox.checked
                };

                let result = await SP.post<any>("/api/v1/stockingLot/update", postData);

                location.reload(); //maybe
                //this.close();
            });

        }

        hide() {
            this.bc_menu.style.display = "none";
        }

        open_bc() {
            this.hide();
            this.container.style.display = "block";
            this.bc_menu.style.display = "block";
        }

        async open(lot: SP.StockingLotInfo) {
            console.log("LOT:", lot);
            this.reset();
            this.current = lot;
            this.item_headline.innerHTML = lot.item.description;
            this.image_contianer.innerHTML = `<img src="${lot.item.imageUrl}" style='max-width:200px; max-height:200px;' />`;
            this.batch_input.value = lot.batchNumber;
            this.arrival_input.value = lot.arrivalDateRaw;
            this.expiration_input.value = lot.expirationDateRaw;
            this.quarantine_checkbox.checked = lot.quarantine;
            this.return_checkbox.checked = lot.isReturn;
            this.expiration_container.style.display = lot.item.expirable ? "block" : "none";
            this.open_bc();
        }

        close() {
            this.reset();
            super.close();
        }

        reset() {
            this.batch_input.value = "";
            this.arrival_input.value = "";
            this.expiration_input.value = "";
        }

        initialize() {

            this.bc_menu.innerHTML = `

                <div class="setting_group setting_group-custom">
                    
                    <div class="setting-custom">
                    <h1 class="terminal-modal-h1">${SP.Localize("word_edit")} LOT</h1>   
                    <div class="image_container" style="text-align:center"></div>
                    <h2 class='item_headline' style="color:gray"></h2>
                        <div class="terminal-form-input-container">
                        <b>${SP.Localize("word_arrival")}</b>
                            <input class="terminal-form-input el_arrival" type="datetime-local" placeholder="${SP.Localize("word_arrival")}" />
                        </div>

                        <div class="terminal-form-input-container el_expiration_container">
                            <b>${SP.Localize("word_expiration")}</b>
                            <input class="terminal-form-input el_expiration" type="date" placeholder="${SP.Localize("word_expiration")}" />
                        </div>

                        <div class="terminal-form-input-container">
                            <b>${SP.Localize("word_batch")}</b>
                            <input class="terminal-form-input el_batch" type="text" placeholder="${SP.Localize("word_batch")}" />
                        </div>

                        <div class="terminal-form-input-container">
                            <input class="terminal-form-input el_is_return" type="checkbox" />
                            <b style="padding-left:10px; vertical-align: -8px">${SP.Localize("sentance_is_return")}</b>
                        </div>

                        <div class="terminal-form-input-container">
                            <input class="terminal-form-input el_quarantine" type="checkbox" />
                            <b style="padding-left:10px; vertical-align: -8px">${SP.Localize("sentance_quarantine_items")}</b>
                        </div>
                    </div>
                </div>

                <div class="btn noselect grad-green"><span class="action">${SP.Localize("word_save")}</span></div>
            `;

            this.item_headline = this.bc_menu.querySelector(".item_headline");
            this.image_contianer = this.bc_menu.querySelector(".image_container");
            this.batch_input = this.bc_menu.querySelector(".el_batch");
            this.arrival_input = this.bc_menu.querySelector(".el_arrival");
            this.expiration_input = this.bc_menu.querySelector(".el_expiration");
            this.quarantine_checkbox = new SP.CheckboxDoodle(this.bc_menu.querySelector(".el_quarantine"));
            this.return_checkbox = new SP.CheckboxDoodle(this.bc_menu.querySelector(".el_is_return"));
            this.expiration_container = this.bc_menu.querySelector(".el_expiration_container");
            this.container.appendChild(this.bc_menu);

            this.quarantine_checkbox.track.style.float = this.return_checkbox.track.style.float = "left";
        }

    }
}